import { refreshAccessToken } from "@/features/auth/authApi"
import { tokenStorage } from "@/features/auth/tokenStorage"
import type { TokenResponse } from "@/lib/api/http"
import { ApiError } from "@/lib/api/http"

type SetSession = (tokens: TokenResponse) => void

/** Один повтор запроса после refresh при 401 */
export const withAccessTokenRetry = async <T>(
  accessToken: string | null,
  setSession: SetSession,
  request: (token: string) => Promise<T>,
): Promise<T> => {
  if (!accessToken) {
    throw new ApiError("Требуется вход", 401, null)
  }
  try {
    return await request(accessToken)
  } catch (e) {
    if (!(e instanceof ApiError) || e.status !== 401) {
      throw e
    }
    const refresh = tokenStorage.getRefreshToken()
    if (!refresh) {
      throw e
    }
    const tokens = await refreshAccessToken(refresh)
    setSession(tokens)
    return await request(tokens.access_token)
  }
}
